// components/RegisterPage.js

import React from 'react';
import { useHistory } from 'react-router-dom';
import RegisterForm from './RegisterForm';

const RegisterPage = ({ onLogin }) => {
  const history = useHistory();

  const handleRegistrationSuccess = () => {
    history.push('/');
  };

  return (
    <div>
      {/* Pass the onLogin prop to RegisterForm */}
      <RegisterForm onRegisterSuccess={handleRegistrationSuccess} onLogin={onLogin} />
    </div>
  );
};

export default RegisterPage;
